import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Filtro } from 'src/app/models/filtro';
import { CarregandoService } from 'src/app/services/carregando.service';
import { FreteService } from 'src/app/services/frete.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { ProdutoService } from 'src/app/services/produto.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { ImportarProdutosModalComponent } from '../importar-produtos-modal/importar-produtos-modal.component';
import { Modalidade } from 'src/app/models/modalidade';
import { TransportadoraService } from 'src/app/services/transportadora.service';
import { ModalidadeService } from 'src/app/services/modalidade.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { FornecedorService } from 'src/app/services/fornecedor.service';
import { Transportadora } from 'src/app/models/transportadora';

@Component({
  selector: 'app-importar-tabela-de-fretes-modal',
  templateUrl: './importar-tabela-de-fretes-modal.component.html',
  styleUrls: ['./importar-tabela-de-fretes-modal.component.scss']
})
export class ImportarTabelaDeFretesModalComponent implements OnInit {
  carregando = true;
  campoOrdenacao = 'nome';
  ordenarDesc = false;
  percentuais = false;

  paginacao = { tamanhoMaximo: 5, total: 0, paginaAtual: 1 };
  listaDeItensPorPagina = [];
  itensPorPagina = 10;
  filtroNome: Filtro = { Propriedade: 'descricao', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];
  public config: PerfectScrollbarConfigInterface = {};

  selectedFile: File;
  cdSelecionado;

  usarCentroDeDistribuicao = false;
  usarMultiFornecedores = false;
  fornecedores = [];
  modalidades: Modalidade[] = [];
  modalidadeSelecionada;
  tipoOperacao: number = 0;
  transportadoras: Transportadora[] = [];
  transportadoraSelecionada = undefined;
  titulo: string;

  exibirModalidade: boolean = false;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    public dialogRef: MatDialogRef<ImportarTabelaDeFretesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private utilitarioService: UtilitarioService,
    public dialog: MatDialog,
    private freteService: FreteService,
    private transportadoraService: TransportadoraService,
    private fornecedorService: FornecedorService,
    private premissasService: PremissasService,
    private modalidadeService: ModalidadeService
  ) {
    this.cdSelecionado = this.data.cdSelecionado;
    this.percentuais = this.data.percentuais;
    this.tipoOperacao = this.data.tipoOperacao;
    this.modalidadeSelecionada = this.data.idMod;
    this.transportadoraSelecionada = this.data.idTransp;
    this.exibirModalidade = this.data.exibirModalidade;

    this.titulo = this.tipoOperacao == 0 ? 'Baixar Modelo' : this.percentuais ? 'Importar Percentuais de Fretes' : 'Importar Tabela de Fretes';
  }

  ngOnInit() {
    this.buscarTransportadoras();
    this.buscarFornecedores();
    this.buscarPremissaCentroDeDistribuicao();
    this.buscarPremissaMultFornecedor();

    if (this.exibirModalidade) {
      this.buscarModalidadesExistentes();
    }
  }

  importarPercentuais() { }

  buscarModalidadesExistentes() {
    if (!this.exibirModalidade) {
      return;
    }

    const idTransp = this.transportadoraSelecionada !== null && this.transportadoraSelecionada !== undefined && this.transportadoraSelecionada !== "-1" ? this.transportadoraSelecionada : null;

    this.carregandoService.mostra('buscarModalidades');

    this.modalidadeService.listarModalidadesExistentes(idTransp).subscribe(data => {
      this.modalidades = data;

      // const mod = new Modalidade();
      // mod.id = -1;
      // mod.descricao = 'SEM MODALIDADE';

      // if (!this.modalidades.some(m => m.id === mod.id)) {
      //   this.modalidades.unshift(mod);
      // }

      // if (!this.modalidadeSelecionada || !this.modalidades.some(m => m.id === this.modalidadeSelecionada)) {
      //   this.modalidadeSelecionada = mod.id;
      // }

      this.carregandoService.esconde('buscarModalidades');
    }, (erro) => {
      this.carregandoService.esconde('buscarModalidades');
      this.notificacaoService.erro('Não foi possível buscar as modalidades!');
    });
  }

  buscarTransportadoras() {
    this.carregandoService.mostra('buscarTransportadoras');

    this.transportadoraService.consultarTransportadoras().subscribe(dados => {
      this.transportadoras = dados;

      const novaTransp = new Transportadora();
      novaTransp.id = "-1";
      novaTransp.nome = 'SEM TRANSPORTADORA';

      if (!this.transportadoras.some(transp => transp.id === novaTransp.id)) {
        this.transportadoras.unshift(novaTransp);
      }

      if (!this.transportadoraSelecionada) {
        this.transportadoraSelecionada = novaTransp.id;
      }

      this.carregandoService.esconde('buscarTransportadoras');
    }, (erro) => {
      this.carregandoService.esconde('buscarTransportadoras');
    });
  }

  buscarPremissaCentroDeDistribuicao() {
    this.carregandoService.mostra('buscarPremissaCentroDeDistribuicao');
    this.premissasService.consultarCentroDeDistribuicao().subscribe(
      centro => {
        this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
        if (centro.valor) {
          this.usarCentroDeDistribuicao = true;
          this.buscarFornecedores();
        }
      },
      err => {
        this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarPremissaMultFornecedor() {
    this.carregandoService.mostra('buscarPremissaMultFornecedor');
    this.premissasService.consultarMultiFornecedores().subscribe(
      data => {
        this.carregandoService.esconde('buscarPremissaMultFornecedor');
        if (data.valor) {
          this.usarMultiFornecedores = true;
          this.buscarFornecedores();
        }
      },
      err => {
        this.carregandoService.esconde('buscarPremissaMultFornecedor');
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarFornecedores() {
    this.carregandoService.mostra('buscarFornecedores');
    this.fornecedorService.consultarFornecedores().subscribe(
      forn => {
        this.carregandoService.esconde('buscarFornecedores');
        this.fornecedores = forn;
      },
      err => {
        this.carregandoService.esconde('buscarFornecedores');
        this.notificacaoService.erro(err);
      }
    );
  }

  importar() {
    const dados = new FormData();

    const modalidade = this.modalidadeSelecionada !== null && this.modalidadeSelecionada !== undefined
      ? this.modalidadeSelecionada
      : null;
    const transportadora = this.transportadoraSelecionada !== null && this.transportadoraSelecionada !== undefined
      ? this.transportadoraSelecionada
      : null;

    dados.append('arquivo', this.selectedFile);
    this.carregandoService.mostra('importar');
    this.freteService.importarFretes(dados, this.cdSelecionado, modalidade, transportadora).subscribe((resp) => {
      this.carregandoService.esconde('importar');
      this.notificacaoService.sucesso('Fretes importados com sucesso!!!');
      this.fechar();
    }, (erro) => {
      this.carregandoService.esconde('importar');
      this.notificacaoService.erro(erro);
    });
  }

  exportarFretes() {
    this.carregandoService.mostra('exportar');

    const modalidade = this.modalidadeSelecionada !== null && this.modalidadeSelecionada !== undefined
      ? this.modalidadeSelecionada
      : null;
    const transportadora = this.transportadoraSelecionada !== null && this.transportadoraSelecionada !== undefined
      ? this.transportadoraSelecionada
      : null;
    const cds = this.cdSelecionado ? [this.cdSelecionado] : null;

    this.freteService.exportarFretes(cds, false, modalidade, transportadora).subscribe(
      (arq) => {
        const nomeCD = (this.usarCentroDeDistribuicao || this.usarMultiFornecedores) && this.cdSelecionado
          ? this.fornecedores.find(p => p.id === this.cdSelecionado).descricao
          : null;

        const nomeMod = modalidade && modalidade != -1
          ? this.modalidades.find(m => m.id === modalidade).descricao
          : null;

        const nomeTransp = transportadora && transportadora != "-1"
          ? this.transportadoras.find(t => t.id === transportadora).nome
          : null;

        let nomeArquivo = 'TabelaDeFrete';

        if (nomeCD && nomeTransp && nomeMod) {
          nomeArquivo += `_${nomeCD}_${nomeTransp}_${nomeMod}.xlsx`;
        } else if (nomeCD && nomeTransp) {
          nomeArquivo += `_${nomeCD}_${nomeTransp}.xlsx`;
        } else if (nomeCD && nomeMod) {
          nomeArquivo += `_${nomeCD}_${nomeMod}.xlsx`;
        } else if (nomeMod && nomeTransp) {
          nomeArquivo += `_${nomeMod}_${nomeTransp}.xlsx`;
        } else if (nomeCD) {
          nomeArquivo += `_${nomeCD}.xlsx`;
        } else if (nomeMod) {
          nomeArquivo += `_${nomeMod}.xlsx`;
        } else if (nomeTransp) {
          nomeArquivo += `_${nomeTransp}.xlsx`;
        } else {
          nomeArquivo += '.xlsx';
        }

        this.utilitarioService.saveBlob(arq, nomeArquivo);
        this.carregandoService.esconde('exportar');
      },
      (err) => {
        this.carregandoService.esconde('exportar');
        this.notificacaoService.erro(err);
      }
    );
  }

  fechar() {
    this.dialogRef.close({ cd: this.cdSelecionado, idTransp: this.transportadoraSelecionada, idMod: this.modalidadeSelecionada });
  }

  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
  }

  excluirArquivo() {
    this.selectedFile = undefined;
  }
}
